import { IconX } from "@tabler/icons-react";
import ReactModal from "react-modal";
import './modal.scss'

export const Modal = ({isOpen, onAfterClose = () => {}, close, title, titleChildren, children, style}) => {
  return (
		<ReactModal
			isOpen={isOpen}
			onAfterClose={onAfterClose}
			closeTimeoutMS={500}
			appElement={document.getElementById('root')}
			onRequestClose={() => close()}
			parentSelector={() => document.querySelector('#root')}
			style={{
				content: {
					padding: 16
				},
				...style
			}}
		>

			{title ? <div className="ReactModal__Header">
				<div className="ReactModal__HeaderTitle">
					<p>{title}</p>
					{titleChildren}
				</div>
				<button onClick={() => close()}>
					<IconX size={24}/>
				</button>
			</div> : <button onClick={() => close()} className="ReactModal__Absolute-X">
					<IconX size={24}/>
				</button>}
			{children}
		</ReactModal>
  );
};
